<button #buttonElement customButtonSwitch [isVisible]="true" class="custom-button-switch">
  <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>
</button>
